import { Controller } from "@hotwired/stimulus";

// Drives the "Reset 2FA" modal on the admin user profile (TMS-1628). The reset is
// audited with a reason, so Confirm stays disabled until one is typed; closing
// the modal clears it so a half-written reason never carries over.
export default class extends Controller {
  static targets = ["reason", "confirmBtn"];

  connect() {
    this._boundShown = this._focusReason.bind(this);
    this._boundHidden = this._reset.bind(this);

    this.element.addEventListener("shown.bs.modal", this._boundShown);
    this.element.addEventListener("hidden.bs.modal", this._boundHidden);
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.modal", this._boundShown);
    this.element.removeEventListener("hidden.bs.modal", this._boundHidden);
  }

  onReasonInput() {
    this.confirmBtnTarget.disabled = this.reasonTarget.value.trim() === "";
  }

  _focusReason() {
    this.reasonTarget.focus();
  }

  _reset() {
    this.reasonTarget.value = "";
    this.confirmBtnTarget.disabled = true;
  }
}
